import { ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { BraintreeApplePayComponentDef } from '@df/module-braintree/apple-pay/braintree-apple-pay.component.def';
import { CheckoutFormComponent } from '../../../checkout/checkout-form.component';
import { CheckoutSummaryStepComponent } from '../../../checkout/checkout-summary-step.component';
import { ResultComponent } from '../../../ui/api/result.component';

@Component({
    selector: 'braintree-apple-pay',
    templateUrl: './braintree-apple-pay.html',
    standalone: true,
    imports: [ResultComponent]
})
export class BraintreeApplePayComponent extends BraintreeApplePayComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        scrollToService: ScrollToService,
        checkoutStepComponent: CheckoutSummaryStepComponent
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }
}
